export const surgeryNameMappings: { [fullName: string]: string } = {
    '笑気麻酔 - ': '笑気',
    '安心リラックス麻酔 - ': '安マ',
    '全身麻酔 - ': '全マ',
    'ハイブリッド麻酔 - HIFU時(笑気麻酔・麻酔クリーム込)': 'ハイブリット(笑気・麻クリ込)',
    'エクスパレル': 'エクスパレル',
    'ペンレス(麻酔テープ)1枚': 'ペンレス',
    '強力麻酔クリーム': '麻クリ',
    '局所麻酔': '局マ',
    'ブロック注射': 'ブロック',
    'いちごバナ治療（毛包分解法）用　局所麻酔(笑気麻酔込)': '局マ',
    '【延長】ハイブリッド麻酔 - HIFU時(笑気麻酔)・麻酔クリーム込)': '【延長】ハイブリット(笑気・麻クリ込)',
    ' 全身麻酔 -  術後管理料': '*オーバーステイ',
    'PRP作成料(1回で6ml)': 'PRP作成（6ml）',
    'PRP(片膝6ml)初回価格': 'PRP（片膝6ml）',
    'PRPシナジー（ヘアフィラー+PRP）オアシス価格': 'PRPシナジー（ヘアフィラー+PRP）',
    'ウルトラフォーマー300shot': 'HIFU300shot',
    'ウルトラフォーマー400shot': 'HIFU400shot',
    'ウルトラフォーマー500shot': 'HIFU500shot',
    'ウルトラフォーマー300shot オアシス価格': 'HIFU300shot',
    'ウルトラフォーマー400shot オアシス価格': 'HIFU400shot',
    'ウルトラフォーマー500shot オアシス価格': 'HIFU500shot',
    '【特殊部位】人中短縮HIFU（白唇） - ': '人中短縮HIFU(白唇)',
    '【特殊部位】人中短縮HIFU（白唇）セット価格': '人中短縮HIFU(白唇)',
    '目周り・額HIFU200SHOT　セット価格': '目周り・額HIFU200SHOT',
    '首HIFUセット価格': '首HIFU',
    '目周り＋人中＋首(プレミア)セット価格': '目周り+人中+首（プレミア）',
    'デンシティ-顔300Shot（単体）': 'デンシティ-顔300Shot',
    'デンシティ-首300Shot（単体）': 'デンシティ-首300Shot',
    'デンシティ-顔300Shot（HIFUと同時施術）': 'デンシティ-顔300Shot',
    'デンシティ-首300Shot（HIFUと同時施術）': 'デンシティ-首300Shot',
    '【オアシス】デンシティ-顔300（単体）': 'デンシティ-顔300Shot',
    '【オアシス】デンシティ-首300Shot（単体）': 'デンシティ-首300Shot',
    '【オアシス】デンシティ-顔300Shot（HIFUと同時施術）': 'デンシティ-顔300Shot',
    '【オアシス】デンシティ-首300Shot（HIFUと同時施術）': 'デンシティ-首300Shot',
    '【オアシス】リジェボト(鼻)※アラガン使用 ': 'リジェボト(鼻)※アラガン使用',
    '【オアシス】リジェボト(鼻)※ナボタ使用 ': 'リジェボト(鼻)※ナボタ使用',
    '【オアシス】リジェボト(中顔面)※アラガン使用　': 'リジェボト(中顔面)※アラガン使用',
    '【オアシス】リジェボト(中顔面)※ナボタ使用': 'リジェボト(中顔面)※ナボタ使用',
    '【オアシス】リジェボト(首)※アラガン使用 ': 'リジェボト(首)※アラガン使用',
    '【オアシス】リジェボト(首)※ナボタ使用': 'リジェボト(首)※ナボタ使用',
    '【オアシス】リジェボト(額)※アラガン使用': 'リジェボト(額)※アラガン使用',
    '【オアシス】リジェボト(額)※ナボタ使用 ': 'リジェボト(額)※ナボタ使用',
};

export const paymantMethodNameMappings: { [fullName: string]: string } = {
    '振込': '銀行振込',
    'カード': 'クレジットカード',
    '現金': '現金払い',
    'ローン': '医療ローン',
    '返金現金': '現金での返金',
    '返金エアペイ': 'AirPAYでの返金',
    '返金アルファ': 'アルファでの返金',
    '返金振込': '銀行振込での返金',
};

export function getShortName(mappings: any, fullName: string): string | undefined {
    return fullName in mappings ? mappings[fullName] : fullName;
}

export function getOfficialPaymantMethodName(name: string, mappings: any = paymantMethodNameMappings): string | undefined {
    let result = name;
    Object.keys(mappings).forEach((key) => {
        if (name.includes(key)) {
            result = mappings[key];
        }
    });
    return result;
}
